import React from 'react';
import { business } from '@/content/business';
import { usePageMeta } from '@/hooks/usePageMeta';

const LegalPage = ({ title, children }: { title: string; children: React.ReactNode }) => {
  usePageMeta(title);
  return (
    <article className="mx-auto max-w-3xl px-4 pb-24 pt-16 sm:px-6 md:pt-24">
      <h1 className="mb-10 text-[clamp(2.75rem,5vw,4.5rem)] leading-none">{title}</h1>
      <div className="space-y-6 leading-relaxed text-mist [&_h2]:mb-2 [&_h2]:mt-10 [&_h2]:text-3xl [&_h2]:text-softwhite">
        {children}
      </div>
    </article>
  );
};

export const Privacy = () => (
  <LegalPage title="Privacy">
    <p>This page explains what GoldCrusade collects through this website and how it is used.</p>
    <h2>What we collect</h2>
    <p>
      When you use “Start for free”, we collect your name, work email, business name, the workflow you describe, the
      area of interest you select, and—if you provide them—your website, current tools, and preferred availability. We
      record whether you opted in to marketing updates.
    </p>
    <h2>How we use it</h2>
    <p>
      We use this information to prepare for and arrange your discovery call, and to follow up about it. Marketing
      updates are only sent if you opted in, and you can unsubscribe at any time.
    </p>
    <h2>Please don’t send sensitive information</h2>
    <p>Do not submit passwords or sensitive customer information through this website.</p>
    <h2>Your choices</h2>
    <p>
      To access, correct, or delete the information you submitted, email{' '}
      <a className="text-link" href={`mailto:${business.email}`}>
        {business.email}
      </a>
      .
    </p>
  </LegalPage>
);

export const Terms = () => (
  <LegalPage title="Terms">
    <p>These terms cover your use of the GoldCrusade website.</p>
    <h2>Website content</h2>
    <p>
      Examples, demonstrations, and sample outputs on this site use fictional business information and are provided for
      illustration. They are not results from client engagements.
    </p>
    <h2>Engagements</h2>
    <p>
      The discovery call is free and carries no obligation. Pilots and consulting engagements are governed by a written
      scope and agreement, which set out deliverables, fees, operating costs, schedule, and responsibilities. Nothing on
      this website guarantees a particular business outcome.
    </p>
    <h2>Contact</h2>
    <p>
      Questions about these terms:{' '}
      <a className="text-link" href={`mailto:${business.email}`}>
        {business.email}
      </a>
      .
    </p>
  </LegalPage>
);
